import AppPage from '@common/hoc/AppPage';
import asyncComponent from '@common/utility/asyncComponent';
import React from 'react';

const EvlReportByAccess = asyncComponent(() =>
  import('../../../modules/evl-report/ReportByAccess'),
);
export default AppPage(() => <EvlReportByAccess />);
